import axios from 'axios'
import { Promotion } from '../../interfaces/promotion'

export const newPromotion = (promotion: Promotion) => {
  return axios.post('/data/sadarbības_partnera_akcija', promotion).then((resp) => resp.data)
}
